import { SkeletonBlock } from '../../SkeletonBlock/SkeletonBlock';

export function PlayerSlot() {
  return (
    <div className="flex flex-col items-center shrink-0">
      <SkeletonBlock className="h-[48px] w-[59px] rounded-[16px]" variant="sunked" />
      <SkeletonBlock className="h-[8px] w-[67px] mt-[10px] rounded-[24px]" variant="sunked" />
      <SkeletonBlock className="h-[8px] w-[67px] mt-[6px] rounded-[24px]" variant="sunked" />
    </div>
  );
}
